export const BlipMethod = {
  GET: "get",
  SET: "set",
  DELETE: "delete",
} as const;
